export default __webpack_public_path__ + "static/media/up-arrow.0ff8c02f.svg";